module.exports = __webpack_public_path__ + "static/media/border-jackpot.009ab2be.png";